<app-admin-toast></app-admin-toast>
<div class="padding-component">
    <app-header [title]="'Objeto auditable'"></app-header>
    
    <app-auditable-object ></app-auditable-object>

</div>